import { isAfter } from 'date-fns'
import React from 'react'
import { useDispatch } from 'react-redux'
import ConfirmModal from '../../../../components/ConfirmModal'
import colors from '../../../../constants/colors'
import useReloadMessages from '../../../../hooks/useReloadMessages'
import api from '../../../../utils/api'
import { captureError } from '../../../../utils/errorTracker'
import { _ } from '../../../../utils/localization'
import { setIsPageLoading } from '../../../events/pageLoadingSlice'
import { addModal } from '../../../modals/modalSlice'
import { showErrorNotification } from '../../../notifications/notificationsSlice'
import sendMessage from '../../sendMessage'
import { S } from './AppointmentScheduleNotification'
import { ScheduleActionsProps } from './DenyScheduleButton'

const CancelScheduleButton = ({
    eventSlug,
    currentUser,
    receiver,
    appointmentSchedule,
    className = '',
    renderCustomButton,
    callback,
}: ScheduleActionsProps) => {
    const dispatch = useDispatch()
    const reloadMessages = useReloadMessages(receiver?.id)

    if (isAfter(new Date(), new Date(appointmentSchedule?.start_date))) {
        return null
    }

    const cancelSchedule = async (close) => {
        try {
            dispatch(setIsPageLoading(true))
            await api.post(`/events/${eventSlug}/appointment_schedules/${appointmentSchedule.id}/cancel/`)
            dispatch(sendMessage({
                eventSlug,
                text: 'CANCELLED',
                receiverId: receiver.id,
                currentUserId: currentUser.id,
                shouldSendEmail: !receiver?.is_online,
                appointmentSchedule,
                callback: reloadMessages,
            }))
            close()
            callback?.()
        } catch (error) {
            captureError(error)
            dispatch(showErrorNotification(_('appointment_schedule.cancel_schedule_failed')))
        } finally {
            dispatch(setIsPageLoading(false))
        }
    }

    const showCancelConfirm = () => {
        dispatch(addModal({
            Component: ({ close }: {close: () => null}) => (
                <ConfirmModal
                    header={_('appointment_schedule.cancel_schedule.modal_header')}
                    body={_('appointment_schedule.cancel_schedule.modal_body')}
                    onConfirm={() => cancelSchedule(close)}
                    close={close}
                    confirmText={_('button.yes')}
                    cancelText={_('button.no')}
                />
            ),
            padding: 30
        }))
    }

    return renderCustomButton ? (
        <div onClick={showCancelConfirm}>
            {renderCustomButton()}
        </div>
    ) : (
        <S.TextButton
            color={colors.icon}
            className={`mr-2 ${className}`}
            onClick={showCancelConfirm}
        >
            {_('button.cancel')}
        </S.TextButton>
    )
}

export default CancelScheduleButton
